import React, { useEffect, useState } from "react";
import axios from "axios";
import { useNavigate } from "react-router-dom";
import Header from "../components/Header";
import Footer from "../components/Footer";
import {
  FaHome,
  FaTshirt,
  FaMobileAlt,
  FaGamepad,
  FaPaw,
  FaCouch,
  FaCar,
  FaMoneyBillWave,
  FaBuilding,
  FaShoppingBag,
  FaPalette,
  FaBook,
  FaDumbbell,
  FaTools,
  FaChair,
  FaMusic,
  FaChild,
  FaHeartbeat,
  FaLeaf,
} from 'react-icons/fa';

const categoryIcons = {
  fashion: <FaTshirt />,
  electronic: <FaMobileAlt />,
  game: <FaGamepad />,
  'pet shop': <FaPaw />,
  furniture: <FaCouch />,
  vehicle: <FaCar />,
  rent: <FaMoneyBillWave />,
  property: <FaBuilding />,
  'house for rent': <FaHome />,
  accessories: <FaShoppingBag />,
  cosmetics: <FaPalette />,
  books: <FaBook />,
  sport: <FaDumbbell />,
  tools: <FaTools />,
  household: <FaChair />,
  music: <FaMusic />,
  kids: <FaChild />,
  health: <FaHeartbeat />,
  gardening: <FaLeaf />,
};

const AllCategories = () => {
  const [categories, setCategories] = useState([]);
  const [selectedCategory, setSelectedCategory] = useState(null);
  const navigate = useNavigate();

  const fetchCategories = async () => {
    try {
      const response = await axios.get(`https://api.theonlysale.com/api/categories/get`);
      setCategories(response.data);
    } catch (error) {
      console.error("Error fetching categories:", error);
    }
  };

  useEffect(() => {
    fetchCategories();
  }, []);

  const handleCategoryClick = (category_id) => {
    setSelectedCategory(category_id); 
    navigate(`/categories/${category_id}`);   };
    return (
      <>
        <Header />
        <div className="mx-auto p-6 sm:p-8 bg-white dark:bg-gray-900">
          <div className="w-full mb-8">
            <h2 className="text-3xl sm:text-4xl font-extrabold mb-10 text-center text-gray-900 dark:text-gray-100">
              All Categories
            </h2>
            <div className="grid grid-cols-2 sm:grid-cols-3 md:grid-cols-4 lg:grid-cols-5 gap-6">
              {categories.slice(0, 19).map((category) => (
                <div
                  key={category.category_id}
                  onClick={() => handleCategoryClick(category.category_id)}
                  className={`cursor-pointer flex flex-col items-center justify-center transition-all duration-300 transform hover:scale-105 ${
                    selectedCategory === category.category_id
                      ? "text-white"
                      : "text-gray-700 dark:text-gray-300"
                  }`}
                >
                  <div
                    className={`flex items-center justify-center rounded-full transition-colors duration-300 ${
                      selectedCategory === category.category_id
                        ? "bg-blue-500 text-white"
                        : "bg-white text-gray-700 border border-gray-300 dark:bg-gray-800 dark:text-gray-300"
                    }`}
                    style={{ width: "90px", height: "90px" }}
                  >
                    <div className="text-3xl">
                      {categoryIcons[category.name.toLowerCase()] || <FaHome />}
                    </div>
                  </div>
                  <span
                    className={`text-center mt-3 font-medium text-lg ${
                      selectedCategory === category.category_id
                        ? "text-white"
                        : "text-gray-700 dark:text-gray-300"
                    }`}
                  >
                    {category.name}
                  </span>
                </div>
              ))}
            </div>
          </div>
        </div>
        <Footer />
      </>
    );
    
  }    

export default AllCategories;
